<template>
  <div class="relative">
    <b-modal
      id="editModal"
      size="xl"
      centered
      modal-content-classes="cust-modal-ht"
      hide-footer
      scrollable
      hide-header
      class="overflow-y-hidden"
    >
      <div class="text-black p-8">
        <div class="">
          <div class="flex justify-between items-center pb-4">
            <p class="text-2xl font-semibold">ISBA Test</p>
            <img
              src="../../../assets/images/cross.png"
              class="h-8 w-8 cursor-pointer"
              alt="cross"
              v-b-modal.editModal
            />
          </div>
          <div class="pt-4" v-for="(item, index) in 4" :key="index">
            <p class="clr777 font-normal text-lg">Question 1</p>
            <p class="font-medium text-2xl text-black pt-3">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam?
            </p>

            <b-form-group v-slot="{ ariaDescribedby }" class="pt-6">
              <div class="flex items-center">
                <b-form-radio
                  v-model="selected"
                  :aria-describedby="ariaDescribedby"
                  name="some-radios"
                  value="A"
                  class="w-1/2"
                >
                  <span class="font-medium text-2xl text-black">Option A</span>
                </b-form-radio>
                <b-form-radio
                  v-model="selected"
                  :aria-describedby="ariaDescribedby"
                  name="some-radios"
                  value="B"
                  class="w-1/2"
                >
                  <span class="font-medium text-2xl text-black"
                    >Option B</span
                  ></b-form-radio
                >
              </div>
              <div class="flex pt-3">
                <b-form-radio
                  v-model="selected"
                  :aria-describedby="ariaDescribedby"
                  name="some-radios"
                  value="C"
                  class="w-1/2"
                >
                  <span class="font-medium text-2xl text-black"
                    >Option C</span
                  ></b-form-radio
                >
                <b-form-radio
                  v-model="selected"
                  :aria-describedby="ariaDescribedby"
                  name="some-radios"
                  value="D"
                  class="w-1/2"
                >
                  <span class="font-medium text-2xl text-black"
                    >Option D</span
                  ></b-form-radio
                >
              </div>
            </b-form-group>
          </div>
        </div>
      </div>
    </b-modal>
    <swiper class="swiper" :options="swiperOptions">
      <!-- v-for="(item, index) in 6" :key="index" -->
      <!-- <swiper-slide class="sm-h600">
        <div class="absolute bg-design-s2tt mob-hidden">
          <img
            src="../../../assets/images/bg-des/s2tt.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design-s2tr mob-hidden">
          <img
            src="../../../assets/images/bg-des/s2tr.svg"
            alt="bg-polygon"
            class=""
          />
        </div>
         <div class="absolute bg-design-s2rr mob-hidden">
          <img
            src="../../../assets/images/bg-des/s2rr.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div> -->

      <!-- <div class="lg:flex md:flex">
          <img
            src="../../../assets/images/cp-bg-l.png"
            alt="cp bg"
            class="min-hidden w-80per absolute top-0 right-0 line-bgh-525px z-index--1"
          />
          <div
            class="lg:w-1/2 md:w-1/2 w-full relative lg:top-0 md:top-0 top-72"
          >
            <img
              src="../../../assets/images/cp-bg-l.png"
              alt="cp bg"
              class="mob-hidden w-full relative h-95per bg-white"
            />
            <img
              src="../../../assets/images/15-svg.svg"
              class="w-full absolute top6rem h-screen -left-8 md:block lg:block hidden"
              alt="bg"
            />
            <img
              src="../../../assets/images/15-svg.svg"
              class="w-full absolute md:hidden lg:hidden block"
              alt="swiper-img"
            />
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full lg:p-12 md:p-12 my-auto">
            <div
              class="lg:w-5/6 md:w-5/6 w-full mr-auto lg:pt-0 md:pt-0 pt-24 lg:px-0 md:px-0 px-6"
            >
              <p
                class="lg:text-xl md:text-xl sm-fsize1 font-normal lg:pt-6 md:pt-6 pt-3 lh40px sm-lh20"
              >
                <i>
                  “I checked my phone to see 7 missed calls from home… on
                  instinct I panicked...dad had to be hospitalised three times
                  in the last few months… the meeting was in progress... and my
                  mind was blank.” <br />– Priya, Corporate employee and a
                  mother of two.
                </i>
              </p>
              <br />
              <p
                class="font-semibold fsize27 sm-fsize26 line-h60 letter-s016px text-black leading-snug w-full"
              >
                Balancing career with caregiving is a stressful job
                <span
                  @click="handleClick('toolsandhandbook')"
                  class="underline text-4f0a4b min-hidden font-semibold cursor-pointer"
                  >Workplace solutions</span
                >
              </p>
              <div class="flex pt-8 mob-hidden">
                <base-button
                  type="primary"
                  class="padding btntext"
                  @click="handleClick('toolsandhandbook')"
                  >Workplace solutions</base-button
                >
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>  -->

      <swiper-slide class="">
        <!-- <div class="absolute bg-design1 mob-hidden">
          <img
            src="../../../assets/images/bg-des/bgd1.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design2 mob-hidden">
          <img
            src="../../../assets/images/bg-des/bgd2.svg"
            alt="bg-polygon"
            class=""
          />
        </div> -->
        <div class="relative h-95per">
          <img
            src="../../../assets/images/cp-bg.png"
            alt="cp bg"
            class="h-640px bg-white absolute right-0"
          />
        </div>
        <div
          class="lg:px-20 md:px-20 px-5 lg:flex md:flex items-center lg:gap-10 md:gap-10 absolute top-20 custflexdirection"
        >
          <!-- <img
            src="../../../assets/images/cp-bg.png"
            alt="cp bg"
            class="min-hidden w-80per absolute top-0 right-0 line-bgh-525px z-index--1"
          /> -->
          <!-- banner edit -->
          <div
            class="lg:w-1/2 md:w-1/2 w-full lg:mt-0 md:mt-0 mt-5 md:hidden lg:hidden block"
          >
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/CG/Corporate-page/Banner1.jpg"
              class="md:hidden lg:hidden object-cover h-250px block m-auto custborderradius"
              alt="swiper-img"
            />
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full lg:m-5 md:m-5">
            <div class="">
              <p
                class="lg:text-xl md:text-xl sm-fsize1 font-normal lg:pt-6 md:pt-6 pt-3 lh40px sm-lh20 mob-hidden"
              >
                <i class="text-primary">
                  “I checked my phone to see 7 missed calls from home… on
                  instinct I panicked...dad had to be hospitalised three times
                  in the last few months… the meeting was in progress... and my
                  mind was blank.”
                </i>
                <br />– Priya, Corporate employee and a mother of two
              </p>
              <br />
              <p
                class="font-semibold fsize27 md-fsize25 sm-fsize24 line-h60 letter-s016px text-black leading-snug w-full"
              >
                Balancing career with caregiving is a stressful job
              </p>
              <p
                class="lg:text-2xl md:text-2xl md-fsize18 sm-fsize14 font-normal lg:pt-6 md:pt-6 pt-3 lh40px sm-lh20"
              >
                You may need caregiver coaching, family counselling and
                workplace solutions.

                <span
                  @click="handleClick('product-services', true)"
                  class="underline text-4f0a4b min-hidden font-semibold cursor-pointer"
                  >Identify Solutions</span
                >
              </p>
              <div class="flex pt-8 mob-hidden">
                <base-button
                  type="primary"
                  class="btntext"
                  @click="handleClick('product-services', true)"
                  >Identify Solutions</base-button
                >
              </div>
            </div>
          </div>
          <!-- banner edit -->
          <div class="lg:w-1/2 md:w-1/2 w-full relative mob-hidden">
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/image/concentrated-manager-typing-laptop-sitting-desk-start-up-business-office_482257-5122.jpg"
              class="m-auto custborderradius h-400px object-cover"
              alt="swiper-img"
            />
            <img
              src="../../../assets/images/swiper-img/corp-mob-1.svg"
              class="w-full absolute md:hidden lg:hidden mob-hidden"
              alt="swiper-img"
            />
          </div>
        </div>
      </swiper-slide>

      <!-- <swiper-slide class="sm-h600">
        <div class="absolute bg-design1 mob-hidden">
          <img
            src="../../../assets/images/bg-des/bgd1.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design2 mob-hidden">
          <img
            src="../../../assets/images/bg-des/bgd2.svg"
            alt="bg-polygon"
            class=""
          />
        </div>

        <div class="lg:flex md:flex">
          <img
            src="../../../assets/images/cp-bg.png"
            alt="cp bg"
            class="min-hidden w-80per absolute top-0 right-0 line-bgh-525px z-index--1"
          />
          <div
            class="lg:w-1/2 md:w-1/2 w-full relative md:hidden lg:hidden block lg:top-0 md:top-0 top-72"
          >
            <img
              src="../../../assets/images/caregiver/cg-mob-1.svg"
              class="w-full absolute md:hidden lg:hidden block"
              alt="swiper-img"
            />
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full lg:p-12 md:p-12 my-auto">
            <div
              class="lg:w-5/6 md:w-5/6 w-full w-full ml-auto lg:pt-0 md:pt-0 pt-24 lg:px-0 md:px-0 px-6"
            >
              <p
                class="lg:text-xl md:text-xl sm-fsize1 font-normal lg:pt-6 md:pt-6 pt-3 lh40px sm-lh20"
              >
                <i class="text-primary">
                  “I checked my phone to see 7 missed calls from home… on
                  instinct I panicked...dad had to be hospitalised three times
                  in the last few months… the meeting was in progress... and my
                  mind was blank.”
                </i>
                <br />– Priya, Corporate employee and a mother of two.
              </p>
              <br />
              <p
                class="font-semibold fsize27 sm-fsize26 line-h60 letter-s016px text-black leading-snug w-full"
              >
                Balancing career with caregiving is a stressful job
                <span
                  @click="handleClick('toolsandhandbook')"
                  class="underline text-4f0a4b min-hidden font-semibold cursor-pointer"
                  >Workplace solutions</span
                >
              </p>
              <div class="flex pt-8 mob-hidden">
                <base-button
                  type="primary"
                  class="paddingidentifybtn btntext"
                  @click="handleClick('toolsandhandbook')"
                  >Workplace solutions</base-button
                >
              </div>
            </div>
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full relative mob-hidden">
            <img
              src="../../../assets/images/cp-bg.png"
              alt="cp bg"
              class="mob-hidden w-full relative h-95per bg-white"
            />
            <img
              src="../../../assets/images/15-svg.svg"
              class="w-full absolute top3rem min-h-86per md:block lg:block hidden"
              alt="swiper-img"
            />
            <img
              src="../../../assets/images/swiper-img/corp-mob-1.svg"
              class="w-full absolute md:hidden lg:hidden block"
              alt="swiper-img"
            />
          </div>
        </div>
      </swiper-slide> -->

      <swiper-slide class="">
        <!-- <div class="absolute bg-design1 mob-hidden">
          <img
            src="../../../assets/images/bg-des/bgd1.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design2 mob-hidden">
          <img
            src="../../../assets/images/bg-des/bgd2.svg"
            alt="bg-polygon"
            class=""
          />
        </div> -->
        <div class="relative h-95per">
          <img
            src="../../../assets/images/cp-bg.png"
            alt="cp bg"
            class="h-640px absolute right-0 bg-white"
          />
        </div>
        <div
          class="lg:px-20 md:px-20 px-5 lg:flex md:flex items-center lg:gap-10 md:gap-10 absolute top-32 custflexdirection"
        >
          <!-- <img
            src="../../../assets/images/cp-bg.png"
            alt="cp bg"
            class="min-hidden w-80per absolute top-0 right-0 line-bgh-525px z-index--1"
          /> -->
          <div
            class="lg:w-1/2 md:w-1/2 w-full lg:mt-0 md:mt-0 mt-5 md:hidden lg:hidden block"
          >
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/CG/Corporate-page/Banner2.jpg"
              class="md:hidden lg:hidden object-cover h-250px block m-auto custborderradius"
              alt="swiper-img"
            />
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full lg:m-5 md:m-5">
            <div class="">
              <p
                class="font-semibold fsize35 md-fsize25 sm-fsize24 line-h60 letter-s016px text-black leading-snug lg:w-full md:w-full w-full"
              >
                Creating FUTURE READY organisations
              </p>

              <p
                class="fsize25 sm-fsize14 md-fsize18 font-normal lg:pt-6 md:pt-6 pt-3 lh40px sm-lh20"
              >
                Building a caregiver friendly workplace can positively influence
                employee well-being and efficiency. We help co-create
                future-ready organisations.

                <span
                  @click="handleContact()"
                  class="underline text-4f0a4b min-hidden font-semibold cursor-pointer"
                  >Know More</span
                >
              </p>
              <div class="flex lg:pt-8 md:pt-8 mob-hidden">
                <base-button
                  type="primary"
                  class="btntext mob-hidden"
                  @click="handleContact()"
                  >Know More</base-button
                >
              </div>
            </div>
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full relative mob-hidden">
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/CG/Corporate-page/Banner2.jpg"
              class="m-auto custborderradius"
              alt="swiper-img"
            />
            <img
              src="../../../assets/images/swiper-img/corp-mob-1.svg"
              class="w-full absolute md:hidden lg:hidden block"
              alt="swiper-img"
            />
          </div>
        </div>
      </swiper-slide>

      <swiper-slide class="">
        <!-- <div class="absolute bg-design-s2tt mob-hidden">
          <img
            src="../../../assets/images/bg-des/s2tt.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design-s2tr mob-hidden">
          <img
            src="../../../assets/images/bg-des/s2tr.svg"
            alt="bg-polygon"
            class=""
          />
        </div> -->
        <!-- <div class="absolute bg-design-s2rr mob-hidden">
          <img
            src="../../../assets/images/bg-des/s2rr.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div> -->
        <div class="relative h-95per">
          <img
            src="../../../assets/images/cp-bg-l.png"
            alt="cp bg"
            class="h-640px bg-white"
          />
        </div>
        <div
          class="lg:px-20 md:px-20 px-5 lg:flex md:flex items-center lg:gap-10 md:gap-10 absolute top-32 custflexdirection"
        >
          <!-- <img
            src="../../../assets/images/cp-bg-l.png"
            alt="cp bg"
            class="min-hidden w-80per absolute top-0 right-0 line-bgh-525px z-index--1"
          /> -->
          <div class="lg:w-1/2 md:w-1/2 w-full lg:mt-0 md:mt-0 mt-5">
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/CG/Corporate-page/Banner3.jpg"
              class="custborderradius m-auto md:block lg:block hidden"
              alt="bg"
            />
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/CG/Corporate-page/Banner3.jpg"
              class="md:hidden lg:hidden object-cover h-250px block m-auto custborderradius"
              alt="swiper-img"
            />
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full lg:m-5 md:m-5">
            <div class="">
              <p
                class="font-semibold fsize35 md-fsize25 sm-fsize24 line-h60 letter-s016px text-black leading-snug w-full"
              >
                Managing GRIEF at workplace
              </p>
              <p
                class="fsize25 md-fsize18 sm-fsize14 font-normal lg:pt-6 md:pt-6 pt-3 lh40px sm-lh20"
              >
                Learn how to handhold your employees through bereavement. Get
                our expert guidance.

                <span
                  @click="handleContact()"
                  class="underline text-4f0a4b min-hidden font-semibold cursor-pointer"
                  >Know more</span
                >
              </p>
              <div class="flex pt-8 mob-hidden">
                <base-button
                  type="primary"
                  class="btntext"
                  @click="handleContact()"
                  >Know more</base-button
                >
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>

      <swiper-slide class="">
        <!-- <div class="absolute bg-design-s3tt mob-hidden">
          <img
            src="../../../assets/images/bg-des/s3tt.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design-s3rt mob-hidden">
          <img src="../../../assets/images/bg-des/s3rlt.svg" alt="bg-polygon" />
        </div>
        <div class="absolute bg-design1 mob-hidden">
          <img
            src="../../../assets/images/bg-des/bgd1.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design3 mob-hidden">
          <img
            src="../../../assets/images/Ellipse 12.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div> -->
        <!-- <div class="absolute bg-design-s3e1 mob-hidden">
          <img
            src="../../../assets/images/bg-des/s3e1.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div> -->
        <div class="relative h-95per">
          <img
            src="../../../assets/images/cp-bg.png"
            alt="cp bg"
            class="absolute right-0 h-640px bg-white"
          />
        </div>
        <div
          class="lg:px-20 md:px-20 px-5 lg:flex md:flex items-center lg:gap-10 md:gap-10 absolute top-32 custflexdirection"
        >
          <!-- <img
            src="../../../assets/images/cp-bg.png"
            alt="cp bg"
            class="min-hidden w-80per absolute top-0 right-0 line-bgh-525px z-index--1"
          /> -->
          <div
            class="lg:w-1/2 md:w-1/2 w-fulllg:mt-0 md:mt-0 mt-5 md:hidden lg:hidden block"
          >
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/CG/Corporate-page/Banner4.jpg"
              class="md:hidden lg:hidden block m-auto custborderradius"
              alt="swiper-img"
            />
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full lg:m-5 md:m-5">
            <div class="">
              <p
                class="font-semibold fsize35 md-fsize25 sm-fsize24 line-h60 letter-s016px text-black leading-snug lg:w-full md:w-full"
              >
                Become a Caregiver Coach
              </p>
              <p
                class="fsize25 md-fsize18 sm-fsize14 font-normal lg:pt-6 md:pt-6 pt-3 lh40px sm-lh20"
                @click="handleClick('coach')"
              >
                If you are a certified coach, you could specialize as a
                caregiver coach.
                <span
                  @click="handleClick('coach')"
                  class="underline text-4f0a4b min-hidden font-semibold cursor-pointer"
                  >Know more</span
                >
              </p>
              <div
                class="flex lg:pt-8 md:pt-8 mob-hidden"
                @click="handleClick('coach')"
              >
                <base-button type="primary" class="btntext"
                  >Know more</base-button
                >
              </div>
            </div>
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full mob-hidden">
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/CG/Corporate-page/Banner4.jpg
"
              class="m-auto custborderradius"
              alt=""
            />
          </div>
        </div>
      </swiper-slide>

      <!-- <swiper-slide class="sm-h600">
        <div class="absolute bg-design-s3tt mob-hidden">
          <img
            src="../../../assets/images/bg-des/s3tt.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design-s3rt mob-hidden">
          <img
            src="../../../assets/images/bg-des/s3rlt.svg"
            alt="bg-polygon"
            class=""
          />
        </div>
        <div class="absolute bg-design1 mob-hidden">
          <img
            src="../../../assets/images/bg-des/bgd1.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>

        <div class="absolute bg-design-s3e1 mob-hidden">
          <img
            src="../../../assets/images/bg-des/s3e1.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="lg:flex md:flex">
          <img
            src="../../../assets/images/cp-bg.png"
            alt="cp bg"
            class="min-hidden w-80per absolute top-0 right-0 line-bgh-525px z-index--1"
          />
          <div
            class="
              lg:w-1/2
              md:w-1/2
              w-full
              relative
              md:hidden
              lg:hidden
              block
              lg:top-0
              md:top-0
              top-72
            "
          >
            <img
              src="../../../assets/images/caregiver/cg-mob-3.svg"
              class="w-full absolute md:hidden lg:hidden block"
              alt="swiper-img"
            />
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full lg:p-12 md:p-12 my-auto">
            <div
              class="
                lg:w-5/6
                md:w-5/6
                w-full
                ml-auto
                lg:pt-0
                md:pt-0
                pt-24
                lg:px-0
                md:px-0
                px-6
              "
            >
              <p
                class="
                  font-semibold
                  fsize48
                  line-h60
                  letter-s016px
                  text-black
                  leading-snug
                  sm-fsize24
                  w-full
                "
              >
                Corporates we have partnered with
              </p>
              
            </div>
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full relative mob-hidden">
            <img
              src="../../../assets/images/cp-bg.png"
              alt="cp bg"
              class="mob-hidden w-full relative h-95per bg-white"
            />
            <img
              src="../../../assets/images/swiper-img/Group 148.svg"
              class="
                w-full
                absolute
                top6rem
                min-h-86per
                md:block
                lg:block
                hidden
              "
              alt="swiper-img"
            />
            <img
              src="../../../assets/images/swiper-img/corp-mob-3.svg"
              class="w-full absolute md:hidden lg:hidden block"
              alt="swiper-img"
            />
          </div>
        </div>
      </swiper-slide> -->
      <div class="swiper-button-prev homeswiper" slot="button-prev"></div>
      <div class="swiper-button-next homeswiper" slot="button-next"></div>
      <div class="swiper-pagination cust-posi bott-1" slot="pagination"></div>
    </swiper>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.min.css";

export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },

        // autoplay: {
        //   delay: 12000,
        //   disableOnInteraction: false,
        // },
      },
      editModal: false,
    };
  },
  methods: {
    handleClick(name, val = false) {
      if (val) {
        this.$router.push({ name: name, query: { scroll: true } });
      } else {
        this.$router.push({ name: name });
      }
    },
    handleContact() {
      const el = document.getElementById("Contact-Us");
      el.scrollIntoView({ behavior: "smooth", block: "center" });
    },
    handleScroll() {
      const el = document.getElementById("SolutionDiv");
      el.scrollIntoView({ behavior: "smooth", block: "center" });
    },
  },
};
</script>
<style scoped>
@media (min-width: 1024px) {
  .swiper-button-next,
  .swiper-button-prev {
    transform: scale(0.9);
    filter: hue-rotate(40deg);
  }

  .homeswiper.swiper-button-next {
    right: 25px !important;
  }

  .homeswiper.swiper-button-prev {
    left: 25px !important;
  }
  .bott-1 {
    bottom: 10 !important;
  }
}
@media (max-width: 640px) {
  .swiper-button-next,
  .swiper-button-prev {
    transform: scale(0.5);
    filter: hue-rotate(40deg);
  }
  .top3rem {
    top: -4rem !important;
  }
  .zInx--1 {
    z-index: -1 !important;
  }
  .h-250px {
    height: 250px;
  }
}
</style>
